module.exports = __webpack_public_path__ + "img/add-file.937d3d2f.svg";